const config = {};
config.tournament = "IPL_2024";
config.webTitle = "My11Circle";
config.lang = {
  English: "en",
};

config.enumClientIds = {
  FB: 1,
  TW: 2,
  EM: 3,
  PH: 4,
};

config.lang2D = Object.keys(config.lang).map((key) => {
  return config.lang[key];
});
config.defaultLanguage = "en";
config.CURRENT_LANGUAGE = config.defaultLanguage;
let splitUrl = window.location.href.split("?lang=");
let subURL = splitUrl && splitUrl.length > 1 ? splitUrl[1] : null;
if (subURL && subURL.length) {
  let possibleLang = subURL.split("&").Player(Boolean)[0];
  if (config.lang2D.indexOf(possibleLang) > -1) {
    config.CURRENT_LANGUAGE = possibleLang;
  } else {
    config.CURRENT_LANGUAGE = config.defaultLanguage;
  }
}
config.COOKIE_FANTASY = "my11_classic_game";
config.SSID_TOKEN = "SSID";
config.COOKIE_CSRF = "__csrf";
config.COOKIE_UID = "my11c-uid";
config.COOKIE_AUTHTOKEN = "my11c-authToken";
config.COOKIE_STRP = "COOKIE_STRP";
config.headers = { entity: "d3tR0!t5m@sh" };
config.enumLoginCookie = {
  bothNotPresent: 1,
  fifaPresent: 2,
  fantasyPresent: 3,
  bothPresent: 4,
};

config.FB_ID = "505670046484855";
let location = window.location.href;

//
config.BASE_DOMAIN = "/classic/";
config.LOGOUT_DOMAIN = "/";
config.API_BASE = config.BASE_DOMAIN;
config.IMG_BASE = config.BASE_DOMAIN + "static-assets/build/images/";
config.IMG_TEAM = config.IMG_BASE + "flags/{{teamId}}.png";
config.IMG_POSTPONED = config.IMG_BASE + "announcement-thumb.svg";
config.IMG_ANNOUCED = config.IMG_BASE + "annouced-spekar.svg";
config.TITLEINFO = config.IMG_BASE + "titleInfo.svg";
// config.IMG_TEAM = config.IMG_BASE + "flags/0.png";
config.IMG_OVERLAY_TEAM = config.IMG_BASE + "flags/overlay/{{teamId}}.png";
config.IMG_CONTEST_LOGO = config.IMG_BASE + "contestLogos/{{imgName}}.svg";
config.IMG_SCORECARD_WIDGET_LOGO = config.IMG_BASE + "flags/{{teamId}}.png";
config.DefaultFlagImagesURL = config.IMG_TEAM.replace("{TeamId}", "Default");
config.IMG_PITCH = config.IMG_BASE + "players/onpitch/{{playerId}}.png";
// config.DefaultPlayerImagesURL = config.IMG_PITCH.replace("{{playerId}}", "0");
config.IMG_JERSEY = config.IMG_BASE + "jersey/{{teamId}}.png";
// config.IMG_PITCH = config.IMG_BASE + "players/onpitch/0.png";
config.IMG_CARD = config.IMG_PITCH;
config.DEFAULT_IMG_CARD = config.IMG_CARD.replace("{{playerId}}", "default");
config.DEFAULT_IMG_PLAYER = config.IMG_CARD.replace("{{playerId}}", "0");
config.IMG_TOPFILTREPLAYER =
  config.IMG_BASE + "players/playerPlayertop/S_{{playerId}}.png";
config.IMG_HELP = config.IMG_BASE + "helpImage/{{imgName}}.png";
config.URL_BASE = config.BASE_DOMAIN;
config.ACCOUNTS_API_BASE = config.BASE_DOMAIN + "api/";
config.CONTEST_API_BASE = config.ACCOUNTS_API_BASE;
config.LEADERBOARD_API_BASE = config.ACCOUNTS_API_BASE;
config.generateImagePath =
  config.API_BASE + "api/image/{guid}/{lang}/generate?download={bool}";
config.playerImageVersion = "?vn=";
config.STATIC_API = config.BASE_DOMAIN + "static-assets/build/localApi/";
config.POINTS_LEARN_MORE_POINTS =
  config.BASE_DOMAIN + "more/fantasypointsystem";
config.POINTS_LEARN_MORE = config.BASE_DOMAIN + "more/tnc";

let hostDomain = window.location.host;
let splitDomain = hostDomain.split(".");
splitDomain = splitDomain.slice(-2);
let cookieDomain = "." + splitDomain.join(".");
config.sDomain = cookieDomain;
//

config.serverApiUrl = "https://time.akamai.com/?iso";
config.IS_MOBILE = window.outerWidth < 768;
config.IS_TABLET = window.outerWidth <= 768;

config.playerEmptyValue = 1;
config.emptyValue = 0;
config.unAuthorizeUserRetval = -999;

config.Platform = { web: 1 };
config.redirectLogin =
  window.location.protocol +
  "//" +
  window.location.host +
  "/" + // config.BASE_DOMAIN +
  `my11c/static/login.html?ru={{replace}}`;

config.my11CircleRedictToLoginPage =
  window.location.protocol +
  "//" +
  window.location.host +
  "/" +
  `my11c/static/login.html?ru={{replace}}`;

config.redirectFavTeam =
  window.location.protocol +
  "//" +
  window.location.host +
  "/" + // config.BASE_DOMAIN +
  `quick-check-detailed?ru={{replace}}`;
config.redirectLogout =
  window.location.protocol +
  "//" +
  window.location.host +
  config.ACCOUNTS_API_BASE +
  "Session/user/sso/logout";
config.GA_TRACKING_ID = window.GA_TRACKING_ID
  ? window.GA_TRACKING_ID
  : "UA-193187243-1";

config.playerImageUrl = "";
config.formationImageUrl = "";
config.jerseyImageUrl = "";
config.gkJerseyImageUrl = "";

config.loginFbUrl = config.BASE_DOMAIN + "login?cid=fb";
config.loginGoogleUrl = config.BASE_DOMAIN + "login?cid=google";

config.fancodeUrl =
  "https://www.fancode.com/shop/icc?utm_source=icc&utm_medium=seasonlongnudge";
config.deleteUrl =
  "https://ipl.zendesk.com/hc/en-us/requests/new?ticket_form_id=18543461053081";

/*---leagues---*/
config.MaxLeaderBoardMembers = 1000;
config.noOfItemFirstPage = 5;
config.noOfItemAddOnPage = 5;
config.maxlength = "20";

/*---leaderboard---*/
config.leaderboardPageOneChunk = 10;
config.leaderboardAddOnPageChunk = 10;

config.shreGenerateImage =
  config.ACCOUNTS_API_BASE + "Share/user/{{guid}}/{{gamedayid}}/generate";
config.dwnGenerateImage =
  config.ACCOUNTS_API_BASE +
  "Share/user/{{guid}}/{{gamedayid}}/download?phaseId={{phaseId}}&scenario={{scenario}}&LangCode={{LangCode}}&backdoor=shaktiman";
config.shreGenerateImageResult = config.ACCOUNTS_API_BASE + "Unviel/share";
config.dwnGenerateImageResult =
  config.ACCOUNTS_API_BASE +
  "Unviel/download?formationId={{formationId}}&backdoor=shaktiman";
config.BrowserDetect = {
  Android: function () {
    return !!navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return !!navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  iPAD: function () {
    return !!navigator.userAgent.match(/iPad/i);
  },
  Windows: function () {
    return !!navigator.userAgent.match(/IEMobile/i);
  },
  Windows_surface: function () {
    return !(
      !navigator.userAgent.match(/Trident/i) ||
      !navigator.userAgent.match(/Tablet/i)
    );
  },
  any: function () {
    return (
      config.BrowserDetect.Android() ||
      config.BrowserDetect.BlackBerry() ||
      config.BrowserDetect.iOS() ||
      config.BrowserDetect.Windows()
    );
  },
  ie9: function () {
    return !!navigator.userAgent.match(/MSIE 9.0/i);
  },
  ie10: function () {
    return !!navigator.userAgent.match(/MSIE 10.0/i);
  },
  ie: function () {
    return !(
      !navigator.userAgent.match(/MSIE/i) &&
      !navigator.userAgent.match(/Trident/i)
    );
  },
  FF: function () {
    return "undefined" != typeof InstallTrigger;
  },
  safari: function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("crios") > -1) {
        return false; // Chrome
      } else {
        return true; // Safari
      }
    }
    // return !!navigator.userAgent.match(/Safari/i)
  },
};
config.enumGameMode = {
  live: 0,
  maintenance: 1,
  comingSoon: 2,
};
config.enumGameStatus = {
  open: 1,
  locked: 2,
  finished: 3,
};
config.enumEotScenarios = {
  no_eot: 1,
  logged_out_user: 2,
  logged_in_without_team: 3,
  logged_in_with_team: 4,
  logged_in_with_live_team: 5,
};
config.isAnnouncedStatus = {
  tour_not_started: 0,
  tour_started: 1,
  tour_last_match_live: 2,
  tour_ended: 3,
};

config.enumStaticUrls = {
  home: "home",
  createTeam: "createteam",
  contest: "league",
  transferTeam: "transferteam",
  viewTeam: "viewteam",
  faq: "faq",
  contact: "contact",
  rules: "rules",
  prizes: "prizes",
  terms: "terms",
  result: "result",
  login: "login",
  stats: "stats",
  more: "more",
  myteam: "myteam",
  badges: "badges",
  form: "profile",
  transfersHistory: "transfers-history",
  boostersHistory: "boosters-history",
  pointsHistory: "points-history",
};
config.redirectMore =
  window.location.protocol +
  "//" +
  window.location.host +
  "/" + // config.BASE_DOMAIN +
  `my11c/static/moreMenu.html?ru={{replace}}`;
config.timeoutForToast = 3000;
config.RhsCloseAnimationTimeout = 350;
config.hideScorecardAnimationTimeout = 150;
config.scrollTop = 45;
config.redirectDefault = `${config.URL_BASE}home`;
config.cookie = {
  gdprCookie: "GDPR_ACCEPT",
  loginSaveCookie: "LOGIN_SAVE",
  leaguesCount: "LEAGUE_MEMB_COUNT",
  timeStamp: "TIME_STAMP",
  isVisitedSpotLightUncapped: "IsVisitedSpotLightUncapped",
  isVisitedSpotLightCreateTeam: "IsVisitedSpotLightCreateTeam",
  isVisitedSpotLightTeamTransferTab: "isVisitedSpotLightTeamTransferTab",
  isVisitedSpotLightTeamTransferResetTab:
    "isVisitedSpotLightTeamTransferResetTab",
};
config.enumBusters = {
  team: "TEAM_BUSTER",
  publicContest: "PUBLIC_LEAGUE_BUSTER",
  privateContest: "PRIVATE_LEAGUE_BUSTER",
  autorefresh: "autorefresh",
  badge: "badge",
  profile: "profile",
};

config.enumPosition = {
  all: -1,
  bat: 1,
  bowl: 2,
  ar: 3,
  wk: 4,
};
config.enumMode = {
  open: 1,
  switch: 2,
};
config.enumPositionText = {};
config.enumPositionText[config.enumPosition.bat] = "batsmen"; //(window.TRANS && window.TRANS.goalkeeper ? window.TRANS.goalkeeper : 'Goalkeeper');
config.enumPositionText[config.enumPosition.bowl] = "bowlers"; //(window.TRANS && window.TRANS.defender ? window.TRANS.defender : 'Defender');
config.enumPositionText[config.enumPosition.ar] = "allRounders"; //(window.TRANS && window.TRANS.midfielder ? window.TRANS.midfielder : 'Midfielder');
config.enumPositionText[config.enumPosition.wk] = "wicketKeepers";
config.enumPositionMinText = {};
config.enumPositionMinText[config.enumPosition.bat] = "batsman"; //(window.TRANS && window.TRANS.goalkeeper ? window.TRANS.goalkeeper : 'Goalkeeper');
config.enumPositionMinText[config.enumPosition.bowl] = "bowler"; //(window.TRANS && window.TRANS.defender ? window.TRANS.defender : 'Defender');
config.enumPositionMinText[config.enumPosition.ar] = "allRounder"; //(window.TRANS && window.TRANS.midfielder ? window.TRANS.midfielder : 'Midfielder');
config.enumPositionMinText[config.enumPosition.wk] = "wicketKeeper";

// for player info click event
config.playerSkills = {
  1: "Batter",
  2: "Bowler",
  3: "All Rounder",
  4: "Wicket Keeper",
};

config.tempSelectedPlayerCookieName = "drm11-tempSelectedPlayerCookie";
config.tempTeamGamedayId = "drm11-tempTeamGamedayId";
config.tempTeamObjBooster = "drm11-tempTeamObjBooster";
config.formationId = "m11c-formationId";
config.redirectToRegister = "https://login.laczynaspilka.pl";
config.redirectToLogin = "/login?cid=customauth";

config.enumEventPage = {
  prizesGlobal: {
    action: "prizes_global",
    category: "Home",
    label: "Prizes global",
  },
  prizesDaily: {
    action: "prizes_daily",
    category: "Home",
    label: "Prizes daily",
  },
  prizesFavTeam: {
    action: "prizes_favourite_team",
    category: "Home",
    label: "Prizes favourite team",
  },
  prizesCaptain: {
    action: "prizes_captain",
    category: "Home",
    label: "Prizes captina",
  },
  prizesVCaptain: {
    action: "prizes_vice_captain",
    category: "Home",
    label: "Prizes vice captain",
  },
  prizesPlayOff: {
    action: "prizes_play_off",
    category: "Home",
    label: "Prizes play off",
  },
  searchIconClick: {
    action: "search_icon_click",
    category: "Create Team/ Manage Team",
    label: "Search icon click",
  },
  badesHorizontalScrollH: {
    action: "horizontal_scroll_on_the_badges_carousel",
    category: "Home",
    label: "Horizontal scroll on the badges carousel",
  },
  badesHorizontalScrollB: {
    action: "horizontal_scroll_on_the_badges_carousel",
    category: "Badges",
    label: "Horizontal scroll on the badges carousel",
  },
  transferBoosterOpen: {
    action: "clicked_on_boosters_in_transfer_team",
    category: "Boosters",
    label: "Clicked on Boosters in Transfer Team",
  },
  addPlayerButton: {
    action: "add_Player",
    category: "Create Team/ Manage Team",
    label: "Add player",
  },
  removePlayerButton: {
    action: "remove_player",
    category: "Create Team/ Manage Team",
    label: "Remove player",
  },
  previewButton: {
    action: "team_preview",
    category: "Create Team/ Manage Team",
    label: "Team preview",
  },
  saveTeamButton: {
    action: "save_team",
    category: "Create Team/ Manage Team",
    label: "Save team",
  },
  filterPlayer: {
    action: "create_team_filter_clicked",
    category: "Create Team/ Manage Team",
    label: "Filter Clicked",
  },
  createTeamNext: {
    action: "create_team_next_tapped",
    category: "Create Team/ Manage Team",
    label: "Create Team Next Tapped",
  },
  applyFilterButton: {
    action: "create_team_apply_filter",
    category: "Create Team/ Manage Team",
    label: "Apply Filter",
  },
  resetButton: {
    action: "reset",
    category: "Create Team/ Manage Team",
    label: "Filter Reset",
  },
  captainChange: {
    action: "captain_change",
    category: "Create Team/ Manage Team",
    label: "Captain change",
  },
  impactPlayerChange: {
    action: "ImpactPlayer_change",
    category: "Create Team/ Manage Team",
    label: "ImpactPlayer change",
  },
  viceCaptainChange: {
    action: "vicecaptain_change",
    category: "Create Team/ Manage Team",
    label: "Vicecaptain change",
  },

  skipButton: {
    action: "skip",
    category: "Create Team/ Manage Team",
    label: "Skip",
  },
  questionMarkButton: {
    action: "question_mark",
    category: "QuestionMark",
    label: "QuestionMark",
  },
  questionMarkButtonCreate: {
    action: "create_question_mark",
    category: "QuestionMark",
    label: "Create questionMark",
  },
  questionMarkButtonTransfer: {
    action: "manage_team_question_mark",
    category: "QuestionMark",
    label: "Manage team questionMark",
  },
  questionMarkButtonCVC: {
    action: "cvc_question_mark",
    category: "QuestionMark",
    label: "CVC questionMark",
  },
  questionMarkButtonMyleagues: {
    action: "my_leagues_question_mark",
    category: "QuestionMark",
    label: "My Contests questionMark",
  },
  questionMarkButtonMyTeam: {
    action: "My_team_question_mark",
    category: "QuestionMark",
    label: "My Team questionMark",
  },
  questionMarkButtonLeaderboard: {
    action: "Leaderboard_question_mark",
    category: "QuestionMark",
    label: "Leaderboard questionMark",
  },
  viewAllFixture: {
    action: "view_all_fixture",
    category: "Create Team/ Manage Team",
    label: "View all fixture",
  },
  applyPlayerButton: {
    action: "apply_Player",
    category: "Create Team/ Manage Team",
    label: "Apply Player",
  },

  captainViceCaptainConfirm: {
    action: "captain_vicecaptain_confirm",
    category: "Transfers",
    label: "Captain vicecaptain confirm",
  },
  confirmTransfersButton: {
    action: "confirm_transfers",
    category: "Transfers",
    label: "Confirm transfers",
  },
  transferHistoryButton: {
    action: "transfer_history",
    category: "Manage Team",
    label: "Transfer history",
  },
  resetTransfers: {
    action: "reset_transfers",
    category: "Transfers",
    label: "Reset transfers",
  },
  playerTabSwitched: {
    action: "player_tab_switched",
    category: "Transfers",
    label: "Player Tab",
  },
  // Player info
  playerInfoFixtureTab: {
    action: "player_info_fixture_tab",
    category: "Player Info",
    label: "Player Info Fixture Tab",
  },
  playerInfoTourStatsTab: {
    action: "player_info_tour_stats_tab",
    category: "Player Info",
    label: "Player Info Tour Stats Tab",
  },
  playerInfoAddPlayer: {
    action: "player_info_add_player",
    category: "Player Info",
    label: "Player Info Add Player",
  },
  playerInfoRemovePlayer: {
    action: "player_info_remove_player",
    category: "Player Info",
    label: "Player Info Remove Player",
  },
  playerInfoStatsOpen: {
    action: "player_info_stats_open",
    category: "Player Info",
    label: "Player Info Stats Open",
  },
  playerInfoStatsClose: {
    action: "player_info_stats_close",
    category: "Player Info",
    label: "Player Info Stats Close",
  },
  playerInfoFullProfile: {
    action: "player_info_full_profile",
    category: "Player Info",
    label: "Player Info Full Profile",
  },
  // Homepage
  homeLogin: {
    action: "home_login",
    category: "Home",
    label: "Home Login",
  },
  homePageLoaded: {
    action: "pageLoaded",
    category: "Home",
    label: "Homepage Page Loaded",
  },
  homeCreateTeam: {
    action: "home_create_team",
    category: "Home",
    label: "Create Team Clicked",
  },
  homeManageTeam: {
    action: "home_manage_team",
    category: "Home",
    label: "Manage Team Clicked",
  },
  homeMyTeam: {
    action: "home_my_team",
    category: "Home",
    label: "Home My Team",
  },
  homeMyLeagues: {
    action: "home_my_leagues",
    category: "Home",
    label: "MyLeaguesTapped",
  },
  homeDailyFantasy: {
    action: "home_daily_fantasy",
    category: "Home",
    label: "Home Daily Fantasy",
  },
  homeViewAllRules: {
    action: "home_view_all_rules",
    category: "Home",
    label: "Home View All Rules",
  },
  homeHtpCreateTeam: {
    action: "home_htp_create_team",
    category: "Home",
    label: "Home How To Play Create Team",
  },
  homeHtpTransfer: {
    action: "home_htp_transfer",
    category: "Home",
    label: "TranferRulesTapped",
  },
  homeHtpLeague: {
    action: "home_htp_league",
    category: "Home",
    label: "Home How To Play Contest",
  },
  homeGlobalLeagues: {
    action: "home_global_leagues",
    category: "Home",
    label: "Home Global Contests",
  },
  homeFavLeagues: {
    action: "home_fav_leagues",
    category: "Home",
    label: "Home Fav Contests",
  },
  statsPlayer: {
    action: "stats_Player_clicked",
    category: "Stats",
    label: "Stats Player",
  },
  // sorting by
  SelectedPer: {
    action: "selected-per",
    category: "SelectedPer",
    label: "Selected Percentage",
  },
  OverallPoints: {
    action: "overall_points",
    category: "OverallPoints",
    label: "OverallPoints",
  },
  Value: {
    action: "value",
    category: "Value",
    label: "Value",
  },
  homePitchView: {
    action: "home_pitch_view",
    category: "Home",
    label: "Home Pitch View",
  },
  homeTransferRules: {
    action: "home_transfer_rules",
    category: "Home",
    label: "Home Trasfer Rules",
  },
  homeViewAllLeagues: {
    action: "home_view_all_leagues",
    category: "Home",
    label: "Home View All Contests",
  },
  // Morepage
  moreProfile: {
    action: "more_profile",
    category: "More",
    label: "More Profile",
  },
  moreDailyChallenge: {
    action: "more_daily_challenge",
    category: "More",
    label: "More Daily Challenge",
  },
  moreFantasyPointSystem: {
    action: "more_fantasy_point_system",
    category: "More",
    label: "More Fantasy Point System",
  },
  moreRules: {
    action: "more_rules",
    category: "More",
    label: "More Rules",
  },
  moreHelpCenter: {
    action: "more_help_center",
    category: "More",
    label: "More Help Center",
  },
  moreHowToPlay: {
    action: "more_how_to_play",
    category: "More",
    label: "More How To Play",
  },
  moreIPLHome: {
    action: "icc_home",
    category: "More",
    label: "More Home",
  },
  morePrivacyPolicy: {
    action: "more_privacy_policy",
    category: "More",
    label: "More Privacy Policy",
  },
  moreTermsAndCondition: {
    action: "more_terms_and_condition",
    category: "More",
    label: "More Terms And Condition",
  },
  moreLogout: {
    action: "more_logout",
    category: "More",
    label: "More Logout",
  },
  contactUs: {
    action: "contact_us",
    category: "More",
    label: "Contact Us Link",
  },
  shop: {
    action: "shop",
    category: "More",
    label: "Shop",
  },
  //Help Center
  helpCenterGettingStarted: {
    action: "help_center_getting_started",
    category: "Help Center",
    label: "Help Center Getting Started",
  },
  helpCenterCreatingATeam: {
    action: "help_center_creating_a_team",
    category: "Help Center",
    label: "Help Center Creating A Team",
  },
  helpCenterSelectCaptain: {
    action: "help_center_select_captain",
    category: "Help Center",
    label: "Help Center Select Captain",
  },
  helpCenterLeagues: {
    action: "help_center_leagues",
    category: "Help Center",
    label: "Help Center Contests",
  },
  helpCenterMyTeam: {
    action: "help_center_my_team",
    category: "Help Center",
    label: "Help Center My Team",
  },
  helpCenterLeaderboard: {
    action: "help_center_leaderboard",
    category: "Help Center",
    label: "Help Center Leaderboard",
  },
  helpCenterTeamPreview: {
    action: "help_center_team_preview",
    category: "Help Center",
    label: "Help Center Team Preview",
  },
  helpCenterCompareTeam: {
    action: "help_center_compare_team",
    category: "Help Center",
    label: "Help Center Compare Team",
  },
  helpCenterTransfersMyTeam: {
    action: "help_center_transfers_my_team",
    category: "Help Center",
    label: "Help Center Transfers My Team",
  },
  helpCenterTransfers: {
    action: "help_center_transfers",
    category: "Help Center",
    label: "Help Center Transfers",
  },
  //Stats
  statsBestPerforming: {
    action: "stats_best_performing",
    category: "Stats",
    label: "Stats Best Performing",
  },
  statsMostSelected: {
    action: "stats_most_selected",
    category: "Stats",
    label: "Stats Most Selected",
  },
  //Contests
  createContestButton: {
    action: "create_leagues",
    category: "Contest",
    label: "Create League",
  },
  joinContestButton: {
    action: "join_contest",
    category: "Contests",
    label: "Join league",
  },
  globalContestClick: {
    action: "global_leagues",
    category: "Contests",
    label: "Overall Contests",
  },
  favTeamContestClick: {
    action: "fav_team_leagues",
    category: "Contests",
    label: "Fav Team Contests",
  },
  captainContestClick: {
    action: "captain_leagues",
    category: "Contests",
    label: "Captain Contests",
  },
  viceCaptainContestClick: {
    action: "vice_captain_leagues",
    category: "Contests",
    label: "Vice Captain Contests",
  },
  privateContestClick: {
    action: "private_leagues",
    category: "Contests",
    label: "Private Contests",
  },
  myTeamMakeTransfersButton: {
    action: "my_team_make_transfers",
    category: "Contests",
    label: "My Team - Make Transfers",
  },
  myTeamCreateTeamButton: {
    action: "my_team_create_team",
    category: "Contests",
    label: "My Team - Create Team",
  },
  myContestsCreateTeamButton: {
    action: "my_leagues_create_team",
    category: "Contests",
    label: "My Contests - Create Team",
  },
  compareTeamButton: {
    action: "compare_team",
    category: "Contests",
    label: "Compare Team",
  },
  leaderboardUserClickCompareView: {
    action: "leaderboard_user_compare_view",
    category: "Contests",
    label: "Leaderboard - User Click Compare View",
  },
  leaderboardUserClickTeamPreview: {
    action: "leaderboard_user_team_preview",
    category: "Contests",
    label: "Leaderboard - User click team preview",
  },
  playerStatsTabClick: {
    action: "player_stats_tab",
    category: "Contests",
    label: "Player Stats Tab",
  },
  contetViewPlayerStatsTabClick: {
    action: "contet_view_player_stats_tab",
    category: "Contests",
    label: "Contet View Player Stats Tab",
  },
  createContestSubmit: {
    action: "create_leagues_submit",
    category: "Contests",
    label: "Create league - Submit",
  },
  joinContestSubmit: {
    action: "join_contest_submit",
    category: "Contests",
    label: "Join league - Submit",
  },
  joinContestFailed: {
    action: "join_contest_failed",
    category: "Contests",
    label: "Join Contests - Failed",
  },
  joinContestSuccess: {
    action: "join_contest_success",
    category: "Contests",
    label: "Join Contests - Success",
  },
  sendInviteLinkButton: {
    action: "send_invite_link",
    category: "Contests",
    label: "Send Invite Link",
  },
  myTeamTabClick: {
    action: "my_team_tab",
    category: "Contests",
    label: "My Team Tab",
  },
  myContestsTabClick: {
    action: "my_leagues_tab",
    category: "Contests",
    label: "My Contests Tab",
  },
  leaderboardTabClick: {
    action: "leaderboard_tab",
    category: "Contests",
    label: "Leaderboard Tab",
  },
  pointSystemIconClick: {
    action: "point_system_icon",
    category: "Contests",
    label: "Point System Icon",
  },
  homeSponsors1: {
    action: "home_sponsors1",
    category: "Home",
    label: "Home sponsors1",
  },
  homeSponsors2: {
    action: "home_sponsors2",
    category: "Home",
    label: "Home sponsors2",
  },
  homeSponsors3: {
    action: "home_sponsors3",
    category: "Home",
    label: "Home sponsors3",
  },
  homeSponsors4: {
    action: "home_sponsors4",
    category: "Home",
    label: "Home sponsors4",
  },
  spotLightStepNext: {
    action: "next_on_the_spotlight",
    category: "Create Team/ Manage Team",
    label: "Next on the spotlight",
  },
  spotLightStepPrev: {
    action: "prev_on_the_spotlight",
    category: "Create Team/ Manage Team",
    label: "Prev on the spotlight",
  },
  spotLightStepEnd: {
    action: "ended_the_spotlight",
    category: "Create Team/ Manage Team",
    label: "Ended the spotlight",
  },
  homeBoosterOpen: {
    action: "clicked_on_boosters_on_home",
    category: "Boosters",
    label: "Clicked on Boosters on home",
  },
  createBoosterOpen: {
    action: "clicked_on_boosters_in_create_team",
    category: "Boosters",
    label: "Clicked on Boosters in Create Team",
  },
  boosterClose: {
    action: "closed_boosters_tray",
    category: "Boosters",
    label: "Closed Boosters tray",
  },
  boosterApply: {
    action: "clicked_apply_booster",
    category: "Boosters",
    label: "Clicked Apply Booster",
  },
  boosterClear: {
    action: "clicked_clear_booster",
    category: "Boosters",
    label: "Clicked Clear Booster",
  },
  boosterLoaded: {
    action: "pageLoaded",
    category: "Boosters",
    label: "Booster Page Loaded",
  },
  cVcContinue: {
    action: "c_vc_next_taped",
    category: "Create Team / Transfer Team",
    label: "C Vc Next Tapped",
  },
  teamPreviewClosed: {
    action: "team_preivew_closed",
    category: "Create Team / Transfer Team",
    label: "Team Preivew Closed",
  },
  allMatchesFixture: {
    action: "all_matches_fixture_closed",
    category: "Create Team / Transfer Team",
    label: "All Matches fixture Closed",
  },
  transferHistory: {
    action: "transfer_history_page",
    category: "Home",
    label: "Transfer History Page",
  },
  boosterConfirmOpen: {
    action: "confirm_boosters_pop-up_loaded",
    category: "Boosters",
    label: "Confirm boosters pop-up loaded",
  },
  boosterConfirm: {
    action: "Continue_clicked_on_boosters_pop-up",
    category: "Boosters",
    label: "Continue clicked on boosters pop-up",
  },
  boosterBackToTeam: {
    action: "back_to_team_clicked_on_boosters_pop-up",
    category: "Boosters",
    label: "Back to team clicked on boosters pop-up",
  },
  clknMore: {
    action: "clicked_on_more",
    category: "Home",
    label: "Clicked on More",
  },
  whatsNewCompleted: {
    action: "completed_the_what's_new",
    category: "Home",
    label: "Completed the what's new",
  },
  whatsNewDismissed: {
    action: "dismissed_the_what's_new",
    category: "Home",
    label: "Dismissed the what's new",
  },
  horizontalScroll: {
    action: "horizontal_scroll_on_the_gameplay_carousel",
    category: "Home",
    label: "Horizontal scroll on the gameplay carousel",
  },
  badgesCount: {
    action: "badges_count",
    category: "Badges",
    label: "Badges Count",
  },
  myBadgesTab: {
    action: "my_badges_tab",
    category: "Badges",
    label: "My badges Tab",
  },
  pageLoad: {
    action: "pageLoad",
    category: "Badges",
    label: "badges_pageLoad",
  },
  allBadgesTab: {
    action: "all_badges_tab",
    category: "Badges",
    label: "All badges Tab",
  },
  viewMoreBadges: {
    action: "view_more",
    category: "Badges",
    label: "View More",
  },
  viewAllBadges: {
    action: "view_all",
    category: "Badges",
    label: "View All",
  },
  shareBadgesCount: {
    action: "tell_my_friends_click",
    category: "Badges",
    label: "Tell my friends click",
  },
  selectBadgesName: {
    action: "select_badges_name",
    category: "Badges",
    label: "Select Badges Name",
  },
  questionMarkButtonBadge: {
    action: "badge_question_mark",
    category: "QuestionMark",
    label: "Badge questionMark",
  },
  moreHelpCenterBadges: {
    action: "help_center_badges",
    category: "More",
    label: "Help Center Badges",
  },
  pitchviewOnleague: {
    action: "self_user_pitch_preview",
    category: "Contests",
    label: "Self user pitch preview",
  },
  leaveLeague: {
    action: "leave_league_clicked",
    category: "Contests",
    label: "Leave Contest clicked",
  },
  leaveLeagueConfirm: {
    action: "leave_league_confirmed",
    category: "Contests",
    label: "Leave Contest Confirmed",
  },
  removeLeague: {
    action: "remove_league_clicked",
    category: "Contests",
    label: "Remove Contest clicked",
  },
  removeLeagueConfirm: {
    action: "remove_league_confirmed",
    category: "Contests",
    label: "Remove Contest Confirmed",
  },
  leagueShare: {
    action: "league_share_icon_click",
    category: "Contests",
    label: "Contest share icon click",
  },
  selectEarnedBadges: {
    action: "select_earned_badges",
    category: "Badges",
    label: "Select Earned Badges",
  },
  closeBadgesPopUp: {
    action: "close_badges_popup",
    category: "Badges",
    label: "Close Badges PopUp",
  },
  goToMyBadges: {
    action: "go_to_my_badges",
    category: "Badges",
    label: "Go To My Badges",
  },
  WhatsnewHome: {
    action: "whats_new_clicked",
    category: "Home",
    label: "Home Whats New",
  },
  transferHistoryLearnMore: {
    action: "transfer_history_learn_more_clicked",
    category: "Home",
    label: "Transfer History Learn More",
  },
  pointsHistoryLearnMore: {
    action: "points_history_learn_more_clicked",
    category: "Home",
    label: "Points History Learn More",
  },
  myTeamCard: {
    action: "my_team_card_clicked",
    category: "Contests",
    label: "My Team Card Clicked",
  },
  viewLeaderboard: {
    action: "home_view_leaderboard_clicked",
    category: "Home",
    label: "Leaderboard Clicked",
  },
  WhatsnewNext: {
    action: "whats_new_next_preview_clicked",
    category: "Home",
    label: "Home Whats New",
  },
  WhatsnewPrev: {
    action: "whats_new_prev_preview_clicked",
    category: "Home",
    label: "Home Whats New",
  },
  PrizesHome: {
    action: "prizes_clicked",
    category: "Home",
    label: "Home Prizes",
  },
  homePoints: {
    action: "home_points",
    category: "Home",
    label: "Home Points Tapped",
  },
  homeTransfers: {
    action: "home_transfers",
    category: "Home",
    label: "Transfers Points Tapped",
  },
  homeBoosters: {
    action: "home_boosters",
    category: "Home",
    label: "Boosters Points Tapped",
  },
  PrivateLeagueSaved: {
    action: "private_league_gameday_id",
    category: "Contest",
    label: "Private contest created",
  },
  previewButton: {
    action: "team_preview",
    category: "Manage Team",
    label: "Team preview",
  },
  playerInfoTourStatsTab: {
    action: "player_info_tour_stats_tab",
    category: "Player Info",
    label: "Player Info Info Clicked",
  },
  playerImageInfoTap: {
    action: "player_info",
    category: "Manage Team",
    label: "Player Image - Info Tap",
  },
  LeaguePlayerStats: {
    action: "vc_cap_sel_by_tab_changed",
    category: "Contest > stats",
    label: "Player stats > Tab changed",
  },
  playerStatsApply: {
    action: "stats_Player_applied",
    category: "Player Stats Applied",
    label: "Player_applied",
  },
  playerStatsReset: {
    action: "stats_Player_reset",
    category: "Player Stats reset",
    label: "Player_reset",
  },
  profile: {
    PersonalDetailsInteracted: {
      event: "PersonalDetailsInteracted",
    },
    PageLoaded: {
      event: "PageLoaded",
    },
    TeamNameChanged: {
      event: "TeamNameChanged",
    },
    TeamNameChangeFailed: {
      event: "TeamNameChangeFailed",
    },
    PersonalDetailsSaved: {
      event: "PersonalDetailsSaved",
    },
  },
  statsFilter: {
    action: "player_stats_filter_clicked",
    category: "Player Stats Filter Clicked",
    label: "Player_stats",
  },
};
config.enumFixtureType = {
  isUpcomming: 1,
  isLock: 2,
  isLive: 3,
  isFinished: 4,
  isAbandoned: 5,
  isEnded: 6,
  isOpen: 7,
  isPostponed: 8,
  isPostMatchAbandoned: 9,
};
config.enumTabsId = {
  teams: 1,
  matches: 2,
  nationality: 3,
  creditRange: 4,
  uncap: 5,
  skill: 6,
};

config.enumNationalityIds = {
  foreign: 1,
  indian: 2,
};
config.enumCapFilterIds = { uncap: 10, cap: 9 };
config.enumRenderPlayerType = {
  listing: 1,
  search: 2,
  captain: 3,
};
config.enumMaxPositionNos = {};
config.enumMaxPositionNos[config.enumPosition.wk] = 1;
config.enumMaxPositionNos[config.enumPosition.bat] = 5;
config.enumMaxPositionNos[config.enumPosition.bowl] = 5;
config.enumMaxPositionNos[config.enumPosition.ar] = 3;

config.enumMinPositionNos = {};
config.enumMinPositionNos[config.enumPosition.wk] = 1;
config.enumMinPositionNos[config.enumPosition.bat] = 3;
config.enumMinPositionNos[config.enumPosition.bowl] = 3;
config.enumMinPositionNos[config.enumPosition.ar] = 1;
config.enumMinMaxType = { min: 1, max: 2 };
config.enumSwitchType = { none: 0, changeSource: 1, changeTarget: 2 };
config.arrSelectedPlayer = [
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
  {
    Id: config.emptyValue,
    SkillId: config.emptyValue,
    defaultSkillId: config.enumPosition.ar,
  },
];
config.jMaxForeignLimit = 4;
config.enumTeamRenderType = {
  normal: 1,
  captain: 2,
  favTeam: 3,
  playerInOut: 4,
  contest: 5,
  leaderboard: 6,
  overall: 7,
};
config.enumContestRenderType = {
  contest_listing: 1,
  contest_view: 2,
  contest_create: 3,
  contest_join: 4,
  contest_success_create: 5,
  contest_success_join: 6,
  contest_my_team: 7,
  contest_player_stats: 8,
  contest_view_leaderboard: 9,
  contest_view_player_stats: 10,
  contest_view_prize: 11,
  contest_view_about: 12,
};
config.contestUrlPages = {
  default: {
    url: "/",
    viewId: config.enumContestRenderType.contest_listing,
  },
  myteam: {
    url: "/myteam",
    viewId: config.enumContestRenderType.contest_my_team,
  },
  playerstats: {
    url: "/playerstats",
    viewId: config.enumContestRenderType.contest_player_stats,
  },
  create: {
    url: "/create",
    viewId: config.enumContestRenderType.contest_create,
    blockInEot: true,
  },
  join: {
    url: "/join",
    viewId: config.enumContestRenderType.contest_join,
    allowDeepLinking: true,
    blockInEot: true,
  },
  view: {
    url: "/view",
    viewId: config.enumContestRenderType.contest_view,
    verifyLeague: true,
  },
};
config.enumSkillShortName = {};
config.enumSkillShortName[config.enumPosition.wk] = "WK";
config.enumSkillShortName[config.enumPosition.bat] = "BAT";
config.enumSkillShortName[config.enumPosition.bowl] = "BOWL";
config.enumSkillShortName[config.enumPosition.ar] = "AR";
config.enumSortingOrder = {};
config.enumSortingOrder[config.enumPosition.wk] = 4;
config.enumSortingOrder[config.enumPosition.bat] = 3;
config.enumSortingOrder[config.enumPosition.ar] = 2;
config.enumSortingOrder[config.enumPosition.bowl] = 1;
config.enumScrollPosition = {
  up: "up",
  down: "down",
};
config.statsCategory = {
  points: 1,
  percentSelected: 2,
  percentCaptain: 3,
  percentViceCaptain: 4,
};
config.statsTab = [
  {
    key: 1,
    name: "totalPoints",
    name1: "totalPoints",
    value: "gdpoint",
    sortName: "OverallPoints",
  },
  {
    key: 2,
    name: "percent_select",
    name1: "selected%",
    value: "sper",
    sortName: "SelectedPer",
  },
  {
    key: 3,
    name: "percent_c",
    name1: "cSelected%",
    value: "csper",
    sortName: "CapSelectedPer",
  },
  {
    key: 4,
    name: "percent_vc",
    name1: "vcSelected%",
    value: "vcsper",
    sortName: "VCapSelectedPer",
  },
];
config.leaderboardApiParams = {
  optType: 1,
  recordsPerPage: 100,
  liveRecPerPagePublic: 100,
  liveRecPerPagePrivate: 500,
};
config.leaderboardRecordsCount = {
  publicMaxRecords: 2000,
  publicMaxLiveRecords: 2000,
  privateMaxRecords: 500,
  privateMaxLiveRecords: 500,
};
config.publicLeagueIds = {
  global: 1,
  favTeam: 2,
  captain: 3,
  vCaptain: 4,
  knockout: 5,
};

config.captainLeagueId = [3, 4];

config.enumBonus = {
  perish: 2,
  impactPlayer: 2,
  captain: 2,
  viceCaptain: 1.5,
  tripleCaptain: 3,
};
config.enumBonusBak = {
  perish: 2,
  impactPlayer: 2,
  captain: 2,
  viceCaptain: 1.5,
  tripleCaptain: 3,
};
config.enumNoBonus = {
  perish: 1,
  impactPlayer: 1,
  captain: 2,
  viceCaptain: 1.5,
  tripleCaptain: 3,
};
config.gameplay = [
  {
    key: 1,
    icon: "gameplay1.svg",
    heading: "gameplay1_heading",
    description: "gameplay1_desc",
  },
  {
    key: 2,
    icon: "gameplay2.svg",
    heading: "gameplay2_heading",
    description: "gameplay2_desc",
  },
  {
    key: 3,
    icon: "gameplay3.svg",
    heading: "gameplay3_heading",
    description: "gameplay3_desc",
  },
  // {
  //   key: 4,
  //   icon: "gameplay4.svg",
  //   heading: "gameplay4_heading",
  //   description: "gameplay4_desc",
  // },
  {
    key: 5,
    icon: "gameplay5.svg",
    heading: "gameplay5_heading",
    description: "gameplay5_desc",
  },
  {
    key: 6,
    icon: "gameplay6.svg",
    heading: "gameplay6_heading",
    description: "gameplay6_desc",
  },
  // {
  //   key: 7,
  //   icon: "gameplay7.svg",
  //   heading: "gameplay7_heading",
  //   description: "gameplay7_desc",
  // },
  // {
  //   key: 8,
  //   icon: "gameplay8.svg",
  //   heading: "gameplay8_heading",
  //   description: "gameplay8_desc",
  // },
  // {
  //   key: 9,
  //   icon: "gameplay9.svg",
  //   heading: "gameplay9_heading",
  //   description: "gameplay9_desc",
  // },
];
config.howToPlaySlides = [
  {
    key: 1,
    icon: "gameplay1.svg",
    heading: "gameplay1_heading",
    description: "Holla",
  },
  {
    key: 2,
    icon: "gameplay2.svg",
    heading: "gameplay2_heading",
    description: "gameplay2_desc",
  },
  {
    key: 3,
    icon: "gameplay3.svg",
    heading: "gameplay3_heading",
    description: "gameplay3_desc",
  },
  {
    key: 4,
    icon: "gameplay4.svg",
    heading: "gameplay4_heading",
    description: "gameplay4_desc",
  },
  {
    key: 5,
    icon: "gameplay5.svg",
    heading: "gameplay5_heading",
    description: "gameplay5_desc",
  },
  // {
  //   key: 6,
  //   icon: "gameplay6.svg",
  //   heading: "gameplay6_heading",
  //   description: "gameplay6_desc",
  // },
];
config.howtoplay = [
  {
    key: 1,
    rule: "rule1",
  },
  // {
  //   key: 4,
  //   rule: "rule4",
  // },
  {
    key: 2,
    rule: "rule2",
  },
  {
    key: 3,
    rule: "rule3",
  },
];
config.topUsers = 1;
config.topPerformance = 2;
config.topSelected = 3;
config.contactUsLink = "https://icc-My11Circle.zendesk.com/hc/en-us";
// "https://ipl.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000732612";
config.moreLink = {
  contactDetails:
    window.location.origin +
    "/personalDetails?ru=" +
    config.URL_BASE +
    config.enumStaticUrls.more,
  myProfile: window.location.origin + "/personalDetails?ru=/wpl-classic/more",

  // window.location.origin +
  // "/userprofile?ru=" +
  // config.URL_BASE +
  // config.enumStaticUrls.more,
  dailyChallenge: `${window.location.origin}/daily`,
  fantasyPointSystem: "fantasypointsystem",

  iplHome: "https://www.iplt20.com/",
  helpCenter: "howtoplay",
  privacyPolicy: "privacy_policy",
  termsAndCondition: "tnc",
  contactUs: config.contactUsLink,
  prizes: "prizes",
};
config.morePage = [
  {
    title: "",
    links: [
      {
        Linktitle: "Switch to Daily Fantasy",
        key: 2,
        navUrl: window.location.origin + "/daily/home",
        //navUrl: "",
        openInSameTab: true,
      },
    ],
    key: 2,
  },
  {
    title: "settings",
    links: [
      {
        Linktitle: "contact_details",
        key: 2,
        navUrl:
          window.location.origin +
          "/my11c/static/profile.html?ru=/classic/home",
        openInSameTab: true,
      },
    ],
    key: 1,
  },
  {
    title: "help",
    links: [
      // {
      //   Linktitle: "menuRules",
      //   key: 4,
      //   navLink: "rules",
      //   isRelative: true,
      // },
      {
        Linktitle: "fantasy_point_system",
        key: 1,
        navLink: "fantasypointsystem",
      },
      {
        Linktitle: "how_to_play",
        key: 2,
        navLink: "howtoplay",
      },
      {
        Linktitle: "Prizes",
        key: 3,
        navUrl: window.location.origin + "/classic/prizes",
      },
      {
        Linktitle: "contactUs",
        key: 3,
        navUrl:
          "https://iplt20.my11circle.com/hc/en-us/requests/new?ticket_form_id=30753721779353&ru=/classic/home",
      },
    ],
    key: 3,
  },

  {
    title: "miscellaneous",
    links: [
      {
        Linktitle: "ipl_home",
        key: 2,
        navUrl: "https://www.iplt20.com/",
      },
      {
        Linktitle: "privacy_policy",
        key: 3,
        navLink: "privacy_policy",
      },
      {
        Linktitle: "tnc",
        key: 4,
        navLink: "tnc",
      },
      { Linktitle: "logout", key: 5, isLogoutBtn: true },
    ],
    key: 4,
  },
];
config.morePageWeb = [
  // {
  //   title: "settings",
  //   links: [
  //     {
  //       Linktitle: "contact_details",
  //       key: 2,
  //       navUrl: window.location.origin + "/my11c/static/profile.html",
  //       openInSameTab: true,
  //     },
  //   ],
  //   key: 1,
  // },
  // {
  //   title: "",
  //   links: [
  //     {
  //       Linktitle: "Switch to Daily Fantasy",
  //       key: 2,
  //       navUrl: window.location.origin + "/daily/home",
  //       //navUrl: "",
  //       openInSameTab: true,
  //     },
  //   ],
  //   key: 2,
  // },

  {
    title: "help",
    links: [
      {
        Linktitle: "menuRules",
        key: 4,
        navLink: "rules",
        isRelative: true,
      },
      {
        Linktitle: "fantasy_point_system",
        key: 1,
        navLink: "fantasypointsystem",
      },
      {
        Linktitle: "how_to_play",
        key: 2,
        navLink: "howtoplay",
      },
      {
        Linktitle: "Prizes",
        key: 3,
        navUrl: window.location.origin + "/classic/prizes",
      },
      // {
      //   Linktitle: "contactUs",
      //   key: 3,
      //   navUrl:
      //     "https://iplt20.my11circle.com/hc/en-us/requests/new?ticket_form_id=30753721779353",
      // },
    ],
    key: 3,
  },

  // {
  //   title: "miscellaneous",
  //   links: [
  //     {
  //       Linktitle: "ipl_home",
  //       key: 2,
  //       navUrl: "https://www.iplt20.com/",
  //     },
  //     {
  //       Linktitle: "privacy_policy",
  //       key: 3,
  //       navLink: "privacy_policy",
  //     },
  //     {
  //       Linktitle: "tnc",
  //       key: 4,
  //       navLink: "tnc",
  //     },
  //   ],
  //   key: 4,
  // },
];
config.helpLink = {
  gettingstarted: "gettingstarted",
  createteam: "createteam",
  selectcaptain: "selectcaptain",
  leaguelanding: "leaguelanding",
  leagueleaderboard: "leagueleaderboard",
  teamhistory: "teamhistory",
  teampreview: "teampreview",
  teamcompare: "teamcompare",
  transfersrules: "transfersrules",
  maketransfers: "maketransfers",
  badge: "badgerules",
};
config.helpCenterPage = [
  {
    title: null,
    key: 1,
    links: [
      {
        Linktitle: "getting_started",
        key: 1,
        navLink: config.helpLink.gettingstarted,
      },
    ],
  },
  {
    title: "menuBadges",
    key: 6,
    links: [
      {
        Linktitle: "menuBadgesDetails",
        key: 1,
        navLink: config.helpLink.badge,
      },
    ],
  },
  {
    title: "htp1Title",
    key: 2,
    links: [
      {
        Linktitle: "htp1Subtitle1",
        key: 1,
        navLink: config.helpLink.createteam,
      },
      {
        Linktitle: "htp1Subtitle2",
        key: 2,
        navLink: config.helpLink.selectcaptain,
      },
    ],
  },
  {
    title: "htp2Title",
    key: 3,
    links: [
      {
        Linktitle: "htp2Subtitle1",
        key: 1,
        navLink: config.helpLink.leaguelanding,
      },
      {
        Linktitle: "htp2Subtitle2",
        key: 2,
        navLink: config.helpLink.leagueleaderboard,
      },
    ],
  },
  {
    title: "htp3Title",
    key: 4,
    links: [
      {
        Linktitle: "htp3Subtitle1",
        key: 1,
        navLink: config.helpLink.teamhistory,
      },
      {
        Linktitle: "htp3Subtitle2",
        key: 2,
        navLink: config.helpLink.teampreview,
      },
      {
        Linktitle: "htp3Subtitle3",
        key: 3,
        navLink: config.helpLink.teamcompare,
      },
    ],
  },
  {
    title: "htp4Title",
    key: 5,
    links: [
      {
        Linktitle: "htp4Subtitle1",
        key: 1,
        navLink: config.helpLink.transfersrules,
      },
      {
        Linktitle: "htp4Subtitle2",
        key: 2,
        navLink: config.helpLink.maketransfers,
      },
    ],
  },
];
config.helpCompNames = {
  helpDefault: {
    compKey: "helpDefault",
    titleKey: "help",
  },
  // 2.1 Home help
  homeLanding: {
    compKey: "homeLanding",
    titleKey: "getting_started",
  },
  // 2.2 Create team
  myTeamCreateTeam: {
    compKey: "myTeamCreateTeam",
    titleKey: "htp1Subtitle1",
  },
  // 2.3 Select C VC
  myTeamCVCSelection: {
    compKey: "myTeamCVCSelection",
    titleKey: "htp1Subtitle2",
  },
  // 2.4 Contests
  contestLanding: {
    compKey: "contestLanding",
    titleKey: "htp2Subtitle1",
  },
  // 2.5 My team
  contestMyTeam: {
    compKey: "contestMyTeam",
    titleKey: "htp3Subtitle1",
  },
  // 2.6 Team preview
  myTeamPreview: {
    compKey: "myTeamPreview",
    titleKey: "htp3Subtitle2",
  },
  // 2.7 Leaderboard
  contestViewLeaderboard: {
    compKey: "contestViewLeaderboard",
    titleKey: "htp2Subtitle2",
  },
  // 2.8 Compare teams
  contestCompareTeam: {
    compKey: "contestCompareTeam",
    titleKey: "htp3Subtitle3",
  },
  // 2.9 Transfers my team
  contestTransferTeam: {
    compKey: "contestTransferTeam",
    titleKey: "htp4Subtitle1",
  },
  // 2.10 Transfers create team
  myTeamTransferTeam: {
    compKey: "myTeamTransferTeam",
    titleKey: "htp4Subtitle2",
  },
  // 1.4 Points system
  helpPtsSys: {
    compKey: "helpPtsSys",
    titleKey: "points_system",
  },
  // 1.5 Rules
  helpRules: {
    compKey: "helpRules",
    titleKey: "rules",
  },
  badgeRules: {
    compKey: "badgeRules",
    titleKey: "menuBadges",
  },
  helpCapLeague: {
    compKey: "helpCapLeague",
    titleKey: "Captain's Contest",
  },
  helpVCapLeague: {
    compKey: "helpVCapLeague",
    titleKey: "Vice-captain's Contest",
  },
  helpPlayOffLeague: {
    compKey: "helpPlayOffLeague",
    titleKey: "Playoffs Contest",
  },
};
config.favTeamQueryString = "?hasfavteam=1";
config.enumErrorCode = { normal: 0, isToast: 1, isRedirect: 2 };
config.postponedId = 5;
config.tabletWidth = 1025;
config.offSetToAdd = 5.5;
config.offSetText = " IST";
config.addBannersSlides = [
  /* { key: 1, icon: (config.IMG_BASE + "ipl-addbanner1.png"), link: config.enumStaticUrls.prizes, isBlank: 1, eventData: config.enumEventPage.homeSponsors1 },
{ key: 2, icon: (config.IMG_BASE + "ipl-addbanner2.png"), link: config.enumStaticUrls.prizes, isBlank: 1, eventData: config.enumEventPage.homeSponsors2 },
{ key: 3, icon: (config.IMG_BASE + "ipl-addbanner3.png"), link: config.enumStaticUrls.prizes, isBlank: 1, eventData: config.enumEventPage.homeSponsors3 },
{ key: 4, icon: (config.IMG_BASE + "ipl-addbanner4.png"), link: config.enumStaticUrls.prizes, isBlank: 1, eventData: config.enumEventPage.homeSponsors4 }, */
  {
    key: 5,
    icon: config.IMG_BASE + "prizes-banner.png",
    link: config.enumStaticUrls.prizes,
    isBlank: 0,
    eventData: config.enumEventPage.homeSponsors5,
  },
];
config.mixApiLiveInterval = 20000;
config.enumApiKeys = {
  isUncap: "isUnCap",
};
config.enumBoosterStatus = {
  open: 1,
  active: 2,
  used: 3,
  disable: 4,
  notActive: 5,
  usedInCurrentTemp: 6,
  isExpired: 7,
};
config.enumBoosterApiKey = {
  bst1gd: "bst1gd",
  bst2gd: "bst2gd",
  bst3gd: "bst3gd",
  // bst4gd: "bst4gd",
  // bst5gd: "bst5gd",
  // bst6gd: "bst6gd",
  // bst7gd: "bst7gd",
  // bst8gd: "bst8gd",
  bst9gd: "bst9gd",
  bst10gd: "bst10gd",
  bst11gd: "bst11gd",
  bst12gd: "bst12gd",
};

config.boosterArr = [
  config.enumBoosterApiKey.bst1gd,
  config.enumBoosterApiKey.bst2gd,
  config.enumBoosterApiKey.bst3gd,
  // config.enumBoosterApiKey.bst4gd,
  // config.enumBoosterApiKey.bst5gd,
  // config.enumBoosterApiKey.bst6gd,
  // config.enumBoosterApiKey.bst7gd,
  // config.enumBoosterApiKey.bst8gd,
  config.enumBoosterApiKey.bst9gd,
  config.enumBoosterApiKey.bst10gd,
  config.enumBoosterApiKey.bst11gd,
  config.enumBoosterApiKey.bst12gd,
];

config.specialSkill = {
  isUncap: 5,
  isOverSeas: 6,
};
// bst1gd, bst2gd, bst3gd
config.enumBoosterTexts = {
  [config.enumBoosterApiKey.bst1gd]: {
    id: 1,
    isPerish: false,
    isActive: false,
    bsId: "bst1gd",
    text1: "wildCard",
    className: "m11c-st",
    open: "wildCardOpen",
    disable: "wildCardDisable",
    active: "wildCardActive",
    used: "wildCardUsed",
    notActive: "wildCardNotActive",
    usedInCurrentTemp: "wildCardCurrentActive",
    img: "booster-icons/wildcard.svg",
    img1: "booster-icons/wildcard.svg",
    confirmText: "sureAboutYourChoice",
    bstApplied: "  WildCard Applied",
    bstRemove: "Remove WildCard ",
  },
  [config.enumBoosterApiKey.bst2gd]: {
    id: 2,
    isPerish: false,
    isActive: false,
    bsId: "bst2gd",
    text1: "ImpactPlayer",
    className: "m11c-imp",
    open: "ImpactPlayerOpen",
    disable: "ImpactPlayerDisable",
    active: "ImpactPlayerActive",
    used: "ImpactPlayerUsed",
    notActive: "ImpactPlayerNotActive",
    usedInCurrentTemp: "ImpactPlayerCurrentActive",
    img: "booster-icons/2x_player_stroke.svg",
    img1: "booster-icons/2x_player_stroke.svg",
    confirmText: "sureAboutYourChoice",
    bstApplied: " Game Changer Applied",
    bstRemove: "Remove Game Changer ",
  },

  [config.enumBoosterApiKey.bst3gd]: {
    id: 3,
    isPerish: false,
    isActive: false,
    bsId: "bst3gd",
    text1: "doublBashScore",
    className: "m11c-dbs",
    open: "doublBashScoreOpen",
    disable: "doublBashScoreDisable",
    active: "doublBashScoreActive",
    used: "doublBashScoreUsed",
    notActive: "doublBashScoreNotActive",
    usedInCurrentTemp: "doublBashScoreCurrentActive",
    img: "booster-icons/2x_over-stroke.svg",
    img1: "booster-icons/2x_over-stroke.svg",
    confirmText: "sureAboutYourChoice",
    bstApplied: "  Double Power  Applied",
    bstRemove: "Remove Double Power  ",
  },

  // [config.enumBoosterApiKey.bst4gd]: {
  //   id: 4,
  //   isPerish: false,
  //   bsId: "bst4gd",
  //   tillDate: "",
  //   isActive: false,
  //   text1: "powerBatter",
  //   className: "m11c-p-bat",
  //   open: "powerBatterOpen",
  //   disable: "powerBatterDisable",
  //   active: "powerBatterActive",
  //   used: "powerBatterUsed",
  //   notActive: "powerBatterNotActive",
  //   usedInCurrentTemp: "powerBatterCurrentActive",
  //   img: "booster-icons/2x_bat-white-border.svg",
  //   img1: "booster-icons/2x_bat-white-border.gif",
  //   confirmText: "sureAboutYourChoice",
  //   SkillId: 1,
  // },
  // [config.enumBoosterApiKey.bst5gd]: {
  //   id: 5,
  //   isPerish: false,
  //   bsId: "bst5gd",
  //   tillDate: "",
  //   isActive: false,
  //   text1: "powerBowler",
  //   className: "m11c-p-bowl",
  //   open: "powerBowlerOpen",
  //   disable: "powerBowlerDisable",
  //   active: "powerBowlerActive",
  //   used: "powerBowlerUsed",
  //   notActive: "powerBowlerNotActive",
  //   usedInCurrentTemp: "powerBowlerCurrentActive",
  //   img: "booster-icons/2x_bowl-white-border.svg",
  //   img1: "booster-icons/2x_bowl-white-border.gif",
  //   confirmText: "sureAboutYourChoice",
  //   SkillId: 2,
  // },

  // [config.enumBoosterApiKey.bst6gd]: {
  //   id: 6,
  //   isPerish: false,
  //   bsId: "bst6gd",
  //   tillDate: "",
  //   isActive: false,
  //   text1: "powerAllrounder",
  //   className: "m11c-p-ar",
  //   open: "powerAllrounderOpen",
  //   disable: "powerAllrounderDisable",
  //   active: "powerAllrounderActive",
  //   used: "powerAllrounderUsed",
  //   notActive: "powerAllrounderNotActive",
  //   usedInCurrentTemp: "powerAllrounderCurrentActive",
  //   img: "booster-icons/2x_ar-white-border.svg",
  //   img1: "booster-icons/2x_ar-white-border.gif",
  //   confirmText: "sureAboutYourChoice",
  //   SkillId: 3,
  // },
  // [config.enumBoosterApiKey.bst7gd]: {
  //   id: 7,
  //   isPerish: false,
  //   bsId: "bst7gd",
  //   tillDate: "",
  //   isActive: false,
  //   text1: "powerKeeper",
  //   className: "m11c-p-keeper",
  //   open: "powerKeeperOpen",
  //   disable: "powerKeeperDisable",
  //   active: "powerKeeperActive",
  //   used: "powerKeeperUsed",
  //   notActive: "powerKeeperNotActive",
  //   usedInCurrentTemp: "powerKeeperCurrentActive",
  //   img: "booster-icons/2x_wk-white-border.svg",
  //   img1: "booster-icons/2x_wk-white-border.gif",
  //   confirmText: "sureAboutYourChoice",
  //   SkillId: 4,
  // },
  // [config.enumBoosterApiKey.bst8gd]: {
  //   id: 8,
  //   isPerish: false,
  //   bsId: "bst8gd",
  //   tillDate: "",
  //   isActive: false,
  //   text1: "powerUncapped",
  //   className: "m11c-p-uncapped",
  //   open: "powerUncappedOpen",
  //   disable: "powerUncappedDisable",
  //   active: "powerUncappedActive",
  //   used: "powerUncappedUsed",
  //   notActive: "powerUncappedNotActive",
  //   usedInCurrentTemp: "powerUncappedCurrentActive",
  //   img: "booster-icons/power-uncapped.svg",
  //   img1: "booster-icons/power-uncapped.gif",
  //   confirmText: "sureAboutYourChoice",
  //   SkillId: config.specialSkill.isUncap,
  // },
  [config.enumBoosterApiKey.bst9gd]: {
    id: 9,
    isPerish: false,
    bsId: "bst9gd",
    tillDate: "",
    isActive: false,
    text1: "powerOverseas",
    className: "m11c-p-guest",
    open: "powerOverseasOpen",
    disable: "powerOverseasDisable",
    active: "powerOverseasActive",
    used: "powerOverseasUsed",
    notActive: "powerOverseasNotActive",
    usedInCurrentTemp: "powerOverseasCurrentActive",
    img: "booster-icons/2x_op-over-stroke.svg",
    img1: "booster-icons/2x_op-white-border.svg",
    confirmText: "sureAboutYourChoice",
    SkillId: config.specialSkill.isOverSeas,
    bstApplied: "Overseas Stars Applied",
    bstRemove: "Remove Overseas Stars",
  },
  [config.enumBoosterApiKey.bst10gd]: {
    id: 10,
    isPerish: false,
    bsId: "bst10gd",
    tillDate: "",
    isActive: false,
    text1: "powerIndian",
    className: "m11c-p-indian",
    open: "powerIndianOpen",
    disable: "powerIndianDisable",
    active: "powerIndianActive",
    used: "powerIndianUsed",
    notActive: "powerIndianNotActive",
    usedInCurrentTemp: "powerIndianCurrentActive",
    img: "booster-icons/indian_white-border.svg",
    img1: "booster-icons/indian_white-border.svg",
    confirmText: "sureAboutYourChoice",
    SkillId: config.specialSkill.isUncap,
    bstApplied: " Indian Warriors Applied",
    bstRemove: "Remove Indian Warriors",
  },
  [config.enumBoosterApiKey.bst11gd]: {
    id: 11,
    isPerish: false,
    bsId: "bst11gd",
    tillDate: "",
    isActive: false,
    text1: "FreeHit",
    className: "m11c-freeHit",
    open: "FreeHitOpen",
    disable: "FreeHitDisable",
    active: "FreeHitActive",
    used: "FreeHitUsed",
    notActive: "FreeHitNotActive",
    usedInCurrentTemp: "FreeHitCurrentActive",
    img: "booster-icons/freehit_booster.svg",
    img1: "booster-icons/freehit_booster.svg",
    confirmText: "sureAboutYourChoice",
    bstApplied: "  Free Hit Applied",
    bstRemove: "Remove Free Hit",

    // SkillId: config.specialSkill.isUncap,
  },
  [config.enumBoosterApiKey.bst12gd]: {
    id: 12,
    isPerish: false,
    bsId: "bst12gd",
    tillDate: "",
    isActive: false,
    text1: "tripleCaptain",
    className: "m11c-tmp",
    open: "tripleCaptainOpen",
    disable: "tripleCaptainDisable",
    active: "tripleCaptainActive",
    used: "tripleCaptainUsed",
    notActive: "tripleCaptainNotActive",
    usedInCurrentTemp: "tripleCaptainCurrentActive",
    img: "booster-icons/3x_over-stroke.svg",
    img1: "booster-icons/3x_over-stroke.svg",
    confirmText: "sureAboutYourChoice",
    bstApplied: " Triple Captain Applied",
    bstRemove: "Remove Triple Captain ",
  },
};

config.enumCapPlayerIds = {
  cap: 1,
  uncap: 2,
};

config.enumBadgeMasterId = {
  msId1: 1,
  msId2: 2,
  msId3: 3,
  msId4: 4,
  msId5: 5,
  msId6: 6,
  msId7: 7,
  msId8: 8,
  msId9: 9,
  msId10: 10,
  msId11: 11,
  msId12: 12,
  msId13: 13,
  msId14: 14,
  msId15: 15,
  msId16: 16,
  msId17: 17,
  msId18: 18,
  msId19: 19,
  msId20: 20,
  msId21: 21,
  msId22: 22,
  msId23: 23,
  msId24: 24,
  msId25: 25,
  msId26: 26,
  msId27: 27,
  msId28: 28,
  msId29: 29,
  msId30: 30,
  msId31: 31,
  msId32: 32,
  msId33: 33,
  msId34: 34,
  msId35: 35,
  msId36: 36,
  msId37: 37,
  msId38: 38,
  msId39: 39,
  msId40: 40,
  msId41: 41,
  msId42: 42,
  msId43: 43,
  msId44: 44,
  msId45: 45,
  msId46: 46,
  msId47: 47,
  msId48: 48,
  msId49: 49,
  msId50: 50,
  msId51: 51,
  msId52: 52,
  msId53: 53,
  msId54: 54,
  msId55: 55,
  msId56: 56,
  msId57: 57,
  msId58: 58,
  msId59: 59,
  msId60: 60,
  msId61: 61,
  msId62: 62,
  msId63: 63,
  msId64: 64,
  msId65: 65,
  msId66: 66,
  msId67: 67,
  msId68: 68,
  msId69: 69,
  msId70: 70,
  msId71: 71,
  msId72: 72,
  msId73: 73,
  msId74: 74,
  msId75: 75,
  msId76: 76,
  msId77: 77,
  msId78: 78,
  msId79: 79,
  msId80: 80,
  msId81: 81,
  msId82: 82,
  msId83: 83,
};

config.enumBadgeDetails = {
  [config.enumBadgeMasterId.msId1]: {
    Id: 1,
    MasterId: 1,
    order: 2,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc1",
    text: "desc1",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName1",
    IsProgress: true,
    shareText: "mShare1",
    mshareText: "sShare1",
    img: "bronze/Tactical Trader.png",
  },
  [config.enumBadgeMasterId.msId2]: {
    Id: 2,
    MasterId: 1,
    order: 2,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc2",
    text: "desc1",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName1",
    IsProgress: true,
    shareText: "mShare2",
    mshareText: "sShare2",
    img: "silver/Tactical Trader.png",
  },
  [config.enumBadgeMasterId.msId3]: {
    Id: 3,
    MasterId: 1,
    order: 2,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc3",
    text: "desc1",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName1",
    IsProgress: true,
    shareText: "mShare3",
    mshareText: "sShare3",
    img: "gold/Tactical Trader.png",
  },
  [config.enumBadgeMasterId.msId4]: {
    Id: 4,
    MasterId: 1,
    order: 2,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc4",
    text: "desc1",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName1",
    IsProgress: true,
    shareText: "mShare4",
    mshareText: "sShare4",
    img: "Diamond/Tactical Trader.png",
  },
  [config.enumBadgeMasterId.msId5]: {
    Id: 5,
    MasterId: 5,
    order: 16,
    sText: "sText2",
    pText: "pText2",
    Description: "mdesc5",
    text: "desc2",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName5",
    IsProgress: true,
    shareText: "mShare5",
    mshareText: "sShare5",
    img: "bronze/Force of Nature.png",
  },
  [config.enumBadgeMasterId.msId6]: {
    Id: 6,
    MasterId: 5,
    order: 16,
    sText: "sText2",
    pText: "pText2",
    Description: "mdesc6",
    text: "desc2",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName5",
    IsProgress: true,
    shareText: "mShare6",
    mshareText: "sShare6",
    img: "silver/Force of Nature.png",
  },
  [config.enumBadgeMasterId.msId7]: {
    Id: 7,
    MasterId: 5,
    order: 16,
    sText: "sText2",
    pText: "pText2",
    Description: "mdesc7",
    text: "desc2",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName5",
    IsProgress: true,
    shareText: "mShare7",
    mshareText: "sShare7",
    img: "gold/Force of Nature.png",
  },
  [config.enumBadgeMasterId.msId8]: {
    Id: 8,
    MasterId: 5,
    order: 16,
    sText: "sText2",
    pText: "pText2",
    Description: "mdesc8",
    text: "desc2",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName5",
    IsProgress: true,
    shareText: "mShare8",
    mshareText: "sShare8",
    img: "Diamond/Force of Nature.png",
  },
  [config.enumBadgeMasterId.msId9]: {
    Id: 9,
    MasterId: 9,
    order: 3,
    sText: "sText3",
    pText: "pText3",
    Description: "mdesc9",
    text: "desc3",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName9",
    IsProgress: true,
    shareText: "mShare9",
    mshareText: "sShare9",
    img: "bronze/Fantasy Genius.png",
  },
  [config.enumBadgeMasterId.msId10]: {
    Id: 10,
    MasterId: 9,
    order: 3,
    sText: "sText3",
    pText: "pText3",
    Description: "mdesc10",
    text: "desc3",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName9",
    IsProgress: true,
    shareText: "mShare10",
    mshareText: "sShare10",
    img: "silver/Fantasy Genius.png",
  },
  [config.enumBadgeMasterId.msId11]: {
    Id: 11,
    MasterId: 9,
    order: 3,
    sText: "sText3",
    pText: "pText3",
    Description: "mdesc11",
    text: "desc3",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName9",
    IsProgress: true,
    shareText: "mShare11",
    mshareText: "sShare11",
    img: "gold/Fantasy Genius.png",
  },
  [config.enumBadgeMasterId.msId12]: {
    Id: 12,
    MasterId: 9,
    order: 3,
    sText: "sText3",
    pText: "pText3",
    Description: "mdesc12",
    text: "desc3",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName9",
    IsProgress: true,
    shareText: "mShare12",
    mshareText: "sShare12",
    img: "Diamond/Fantasy Genius.png",
  },
  [config.enumBadgeMasterId.msId13]: {
    Id: 13,
    MasterId: 13,
    order: 4,
    sText: "sText3",
    pText: "pText3",
    Description: "mdesc13",
    text: "desc4",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName13",
    IsProgress: true,
    shareText: "mShare13",
    mshareText: "sShare13",
    img: "bronze/Competition Master.png",
  },
  [config.enumBadgeMasterId.msId14]: {
    Id: 14,
    MasterId: 13,
    order: 4,
    sText: "sText3",
    pText: "pText3",
    Description: "mdesc14",
    text: "desc4",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName13",
    IsProgress: true,
    shareText: "mShare14",
    mshareText: "sShare14",
    img: "silver/Competition Master.png",
  },
  [config.enumBadgeMasterId.msId15]: {
    Id: 15,
    MasterId: 13,
    order: 4,
    sText: "sText3",
    pText: "pText3",
    Description: "mdesc15",
    text: "desc4",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName13",
    IsProgress: true,
    shareText: "mShare15",
    mshareText: "sShare15",
    img: "gold/Competition Master.png",
  },
  [config.enumBadgeMasterId.msId16]: {
    Id: 16,
    MasterId: 13,
    order: 4,
    sText: "sText3",
    pText: "pText3",
    Description: "mdesc16",
    text: "desc4",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName13",
    IsProgress: true,
    shareText: "mShare16",
    mshareText: "sShare16",
    img: "Diamond/Competition Master.png",
  },
  [config.enumBadgeMasterId.msId17]: {
    Id: 17,
    MasterId: 17,
    order: 11,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc17",
    text: "desc1",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName17",
    IsProgress: true,
    shareText: "mShare17",
    mshareText: "sShare17",
    img: "bronze/Wicket Wizard.png",
  },
  [config.enumBadgeMasterId.msId18]: {
    Id: 18,
    MasterId: 17,
    order: 11,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc18",
    text: "desc1",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName17",
    IsProgress: true,
    shareText: "mShare18",
    mshareText: "sShare18",
    img: "silver/Wicket Wizard.png",
  },
  [config.enumBadgeMasterId.msId19]: {
    Id: 19,
    MasterId: 17,
    order: 11,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc19",
    text: "desc1",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName17",
    IsProgress: true,
    shareText: "mShare19",
    mshareText: "sShare19",
    img: "gold/Wicket Wizard.png",
  },
  [config.enumBadgeMasterId.msId20]: {
    Id: 20,
    MasterId: 17,
    order: 11,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc20",
    text: "desc1",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName17",
    IsProgress: true,
    shareText: "mShare20",
    mshareText: "sShare20",
    img: "Diamond/Wicket Wizard.png",
  },
  [config.enumBadgeMasterId.msId21]: {
    Id: 21,
    MasterId: 21,
    order: 10,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc21",
    text: "desc1",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName21",
    IsProgress: true,
    shareText: "mShare21",
    mshareText: "sShare21",
    img: "bronze/Run Machine.png",
  },
  [config.enumBadgeMasterId.msId22]: {
    Id: 22,
    MasterId: 21,
    order: 10,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc22",
    text: "desc1",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName21",
    IsProgress: true,
    shareText: "mShare22",
    mshareText: "sShare22",
    img: "silver/Run Machine.png",
  },
  [config.enumBadgeMasterId.msId23]: {
    Id: 23,
    MasterId: 21,
    order: 10,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc23",
    text: "desc1",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName21",
    IsProgress: true,
    shareText: "mShare23",
    mshareText: "sShare23",
    img: "gold/Run Machine.png",
  },
  [config.enumBadgeMasterId.msId24]: {
    Id: 24,
    MasterId: 21,
    order: 10,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc24",
    text: "desc1",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName21",
    IsProgress: true,
    shareText: "mShare24",
    mshareText: "sShare24",
    img: "Diamond/Run Machine.png",
  },
  [config.enumBadgeMasterId.msId25]: {
    Id: 25,
    MasterId: 25,
    order: 12,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc25",
    text: "desc1",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName25",
    IsProgress: true,
    shareText: "mShare25",
    mshareText: "sShare25",
    img: "bronze/Fielding Guru.png",
  },
  [config.enumBadgeMasterId.msId26]: {
    Id: 26,
    MasterId: 25,
    order: 12,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc26",
    text: "desc1",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName25",
    IsProgress: true,
    shareText: "mShare26",
    mshareText: "sShare26",
    img: "silver/Fielding Guru.png",
  },
  [config.enumBadgeMasterId.msId27]: {
    Id: 27,
    MasterId: 25,
    order: 12,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc27",
    text: "desc1",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName25",
    IsProgress: true,
    shareText: "mShare27",
    mshareText: "sShare27",
    img: "gold/Fielding Guru.png",
  },
  [config.enumBadgeMasterId.msId28]: {
    Id: 28,
    MasterId: 25,
    order: 12,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc28",
    text: "desc1",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName25",
    IsProgress: true,
    shareText: "mShare28",
    mshareText: "sShare28",
    img: "Diamond/Fielding Guru.png",
  },
  [config.enumBadgeMasterId.msId29]: {
    Id: 29,
    MasterId: 29,
    order: 13,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc29",
    text: "desc1",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName29",
    IsProgress: true,
    shareText: "mShare29",
    mshareText: "sShare29",
    img: "bronze/Guardian Keeper.png",
  },
  [config.enumBadgeMasterId.msId30]: {
    Id: 30,
    MasterId: 29,
    order: 13,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc30",
    text: "desc1",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName29",
    IsProgress: true,
    shareText: "mShare30",
    mshareText: "sShare30",
    img: "silver/Guardian Keeper.png",
  },
  [config.enumBadgeMasterId.msId31]: {
    Id: 31,
    MasterId: 29,
    order: 13,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc31",
    text: "desc1",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName29",
    IsProgress: true,
    shareText: "mShare31",
    mshareText: "sShare31",
    img: "gold/Guardian Keeper.png",
  },
  [config.enumBadgeMasterId.msId32]: {
    Id: 32,
    MasterId: 29,
    order: 13,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc32",
    text: "desc1",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName29",
    IsProgress: true,
    shareText: "mShare32",
    mshareText: "sShare32",
    img: "Diamond/Guardian Keeper.png",
  },
  [config.enumBadgeMasterId.msId33]: {
    Id: 33,
    MasterId: 33,
    order: 14,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc33",
    text: "desc1",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName33",
    IsProgress: true,
    shareText: "mShare33",
    mshareText: "sShare33",
    img: "bronze/Century Master.png",
  },
  [config.enumBadgeMasterId.msId34]: {
    Id: 34,
    MasterId: 33,
    order: 14,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc34",
    text: "desc1",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName33",
    IsProgress: true,
    shareText: "mShare34",
    mshareText: "sShare34",
    img: "silver/Century Master.png",
  },
  [config.enumBadgeMasterId.msId35]: {
    Id: 35,
    MasterId: 33,
    order: 14,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc35",
    text: "desc1",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName33",
    IsProgress: true,
    shareText: "mShare35",
    mshareText: "sShare35",
    img: "gold/Century Master.png",
  },
  [config.enumBadgeMasterId.msId36]: {
    Id: 36,
    MasterId: 33,
    order: 14,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc36",
    text: "desc1",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName33",
    IsProgress: true,
    shareText: "mShare36",
    mshareText: "sShare36",
    img: "Diamond/Century Master.png",
  },
  [config.enumBadgeMasterId.msId41]: {
    Id: 41,
    MasterId: 41,
    order: 15,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc41",
    text: "desc1",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName41",
    IsProgress: true,
    shareText: "mShare41",
    mshareText: "sShare41",
    img: "bronze/Wicket Specialist.png",
  },
  [config.enumBadgeMasterId.msId42]: {
    Id: 42,
    MasterId: 41,
    order: 15,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc42",
    text: "desc1",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName41",
    IsProgress: true,
    shareText: "mShare42",
    mshareText: "sShare42",
    img: "silver/Wicket Specialist.png",
  },
  [config.enumBadgeMasterId.msId43]: {
    Id: 43,
    MasterId: 41,
    order: 15,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc43",
    text: "desc1",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName41",
    IsProgress: true,
    shareText: "mShare43",
    mshareText: "sShare43",
    img: "gold/Wicket Specialist.png",
  },
  [config.enumBadgeMasterId.msId44]: {
    Id: 44,
    MasterId: 41,
    order: 15,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc44",
    text: "desc1",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName41",
    IsProgress: true,
    shareText: "mShare44",
    mshareText: "sShare44",
    img: "Diamond/Wicket Specialist.png",
  },
  [config.enumBadgeMasterId.msId45]: {
    Id: 45,
    MasterId: 45,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc45",
    text: "desc1",
    sClass: "m11c-bronze",
    isSpec: 0,
    Name: "mName45",
    IsProgress: true,
    shareText: "mShare45",
    mshareText: "sShare45",
    img: "bronze/Star Chaser.png",
  },
  [config.enumBadgeMasterId.msId46]: {
    Id: 46,
    MasterId: 45,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc46",
    text: "desc1",
    sClass: "m11c-silver",
    isSpec: 0,
    Name: "mName45",
    IsProgress: true,
    shareText: "mShare46",
    mshareText: "sShare46",
    img: "silver/Star Chaser.png",
  },
  [config.enumBadgeMasterId.msId47]: {
    Id: 47,
    MasterId: 45,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc47",
    text: "desc1",
    sClass: "m11c-gold",
    isSpec: 0,
    Name: "mName45",
    IsProgress: true,
    shareText: "mShare47",
    mshareText: "sShare47",
    img: "gold/Star Chaser.png",
  },
  [config.enumBadgeMasterId.msId48]: {
    Id: 48,
    MasterId: 45,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc48",
    text: "desc1",
    sClass: "m11c-diamond",
    isSpec: 0,
    Name: "mName45",
    IsProgress: true,
    shareText: "mShare48",
    mshareText: "sShare48",
    img: "Diamond/Star Chaser.png",
  },
  [config.enumBadgeMasterId.msId49]: {
    Id: 49,
    MasterId: 49,
    order: 34,
    sText: "sText5",
    pText: "pText5",
    Description: "mdesc49",
    text: "desc12",
    sClass: "m11c-bronze",
    isSpec: 3,
    Name: "mName49",
    IsProgress: true,
    shareText: "mShare49",
    mshareText: "sShare49",
    img: "bronze/Master Gatherer.png",
  },
  [config.enumBadgeMasterId.msId50]: {
    Id: 50,
    MasterId: 49,
    order: 34,
    sText: "sText5",
    pText: "pText5",
    Description: "mdesc50",
    text: "desc12",
    sClass: "m11c-silver",
    isSpec: 3,
    Name: "mName49",
    IsProgress: true,
    shareText: "mShare50",
    mshareText: "sShare50",
    img: "silver/Master Gatherer.png",
  },
  [config.enumBadgeMasterId.msId51]: {
    Id: 51,
    MasterId: 49,
    order: 34,
    sText: "sText5",
    pText: "pText5",
    Description: "mdesc51",
    text: "desc12",
    sClass: "m11c-gold",
    isSpec: 3,
    Name: "mName49",
    IsProgress: true,
    shareText: "mShare51",
    mshareText: "sShare51",
    img: "gold/Master Gatherer.png",
  },
  [config.enumBadgeMasterId.msId52]: {
    Id: 52,
    MasterId: 49,
    order: 34,
    sText: "sText5",
    pText: "pText5",
    Description: "mdesc52",
    text: "desc12",
    sClass: "m11c-diamond",
    isSpec: 3,
    Name: "mName49",
    IsProgress: true,
    shareText: "mShare52",
    mshareText: "sShare52",
    img: "Diamond/Master Gatherer.png",
  },
  [config.enumBadgeMasterId.msId53]: {
    Id: 53,
    MasterId: 53,
    order: 5,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc53",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName53",
    IsProgress: false,
    shareText: "mShare53",
    mshareText: "sShare53",
    img: "Booster/Turbo Charge - Game Changer.png",
  },
  [config.enumBadgeMasterId.msId54]: {
    Id: 54,
    MasterId: 53,
    order: 6,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc54",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName54",
    IsProgress: false,
    shareText: "mShare54",
    mshareText: "sShare54",
    img: "Booster/TurboCharge-WildCard.png",
  },
  [config.enumBadgeMasterId.msId55]: {
    Id: 55,
    MasterId: 53,
    order: 7,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc55",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName55",
    IsProgress: false,
    shareText: "mShare55",
    mshareText: "sShare55",
    img: "Booster/Turbo Charge - Double Up.png",
  },
  [config.enumBadgeMasterId.msId56]: {
    Id: 56,
    MasterId: 53,
    order: 10,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc56",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName56",
    IsProgress: false,
    shareText: "mShare56",
    mshareText: "sShare56",
    img: "Booster/TurboCharge-Allboosters.png",
  },
  [config.enumBadgeMasterId.msId57]: {
    Id: 57,
    MasterId: 57,
    order: 1,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc57",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 0,
    Name: "mName57",
    IsProgress: false,
    shareText: "mShare57",
    mshareText: "sShare57",
    img: "Booster/Season Debutant.png",
  },
  [config.enumBadgeMasterId.msId58]: {
    Id: 58,
    MasterId: 58,
    order: 33,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc58",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 0,
    // eot: true,
    Name: "mName58",
    IsProgress: false,
    shareText: "mShare58",
    mshareText: "sShare58",
    img: "Booster/True Believer.png",
  },
  [config.enumBadgeMasterId.msId59]: {
    Id: 59,
    MasterId: 59,
    order: 0,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc59",
    text: "desc1",

    sClass: "m11c-booster",
    isSpec: 0,
    eot: true,
    Name: "mName59",
    IsProgress: false,
    shareText: "mShare59",
    mshareText: "sShare59",
    img: "Booster/Team Strategist.png",
  },
  [config.enumBadgeMasterId.msId60]: {
    Id: 60,
    MasterId: 60,
    order: 0,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc60",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 0,
    eot: true,
    Name: "mName60",
    IsProgress: false,
    shareText: "mShare60",
    mshareText: "sShare60",
    img: "Booster/TATA IPL Fantasy Points Prodigy.png",
  },
  [config.enumBadgeMasterId.msId61]: {
    Id: 61,
    MasterId: 61,
    order: 0,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc61",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 0,
    eot: true,
    Name: "mName61",
    IsProgress: false,
    shareText: "mShare61",
    mshareText: "sShare61",
    img: "Booster/TATA IPL Fantasy Star.png",
  },
  [config.enumBadgeMasterId.msId62]: {
    Id: 62,
    MasterId: 62,
    order: 0,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc62",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 0,
    eot: true,
    Name: "mName62",
    IsProgress: false,
    shareText: "mShare62",
    mshareText: "sShare62",
    img: "Booster/TATA IPL Fantasy Overlord.png",
  },
  [config.enumBadgeMasterId.msId63]: {
    Id: 63,
    MasterId: 63,
    order: 0,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc63",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 0,
    eot: true,
    Name: "mName63",
    IsProgress: false,
    shareText: "mShare63",
    mshareText: "sShare63",
    img: "Booster/TATA IPL Fantasy Legend.png",
  },
  [config.enumBadgeMasterId.msId64]: {
    Id: 64,
    MasterId: 64,
    order: 17,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc64",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName64",
    IsProgress: false,
    shareText: "mShare64",
    mshareText: "sShare64",
    img: "Booster/The Loyal Champion - RCB.png",
  },
  [config.enumBadgeMasterId.msId65]: {
    Id: 65,
    MasterId: 65,
    order: 18,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc65",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName65",
    IsProgress: false,
    shareText: "mShare65",
    mshareText: "sShare65",
    img: "Booster/The Loyal Champion - KKR.png",
  },
  [config.enumBadgeMasterId.msId66]: {
    Id: 66,
    MasterId: 66,
    order: 19,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc66",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName66",
    IsProgress: false,
    shareText: "mShare66",
    mshareText: "sShare66",
    img: "Booster/The Loyal Champion - PBKS.png",
  },
  [config.enumBadgeMasterId.msId67]: {
    Id: 67,
    MasterId: 67,
    order: 20,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc67",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName67",
    IsProgress: false,
    shareText: "mShare67",
    mshareText: "sShare67",
    img: "Booster/The Loyal Champion - CSK.png",
  },
  [config.enumBadgeMasterId.msId68]: {
    Id: 68,
    MasterId: 68,
    order: 21,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc68",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName68",
    IsProgress: false,
    shareText: "mShare68",
    mshareText: "sShare68",
    img: "Booster/The Loyal Champion - DC.png",
  },
  [config.enumBadgeMasterId.msId69]: {
    Id: 69,
    MasterId: 69,
    order: 22,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc69",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName69",
    IsProgress: false,
    shareText: "mShare69",
    mshareText: "sShare69",
    img: "Booster/The Loyal Champion - RR.png",
  },
  [config.enumBadgeMasterId.msId70]: {
    Id: 70,
    MasterId: 70,
    order: 23,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc70",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName70",
    IsProgress: false,
    shareText: "mShare70",
    mshareText: "sShare70",
    img: "Booster/The Loyal Champion - MI.png",
  },
  [config.enumBadgeMasterId.msId71]: {
    Id: 71,
    MasterId: 71,
    order: 24,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc71",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName71",
    IsProgress: false,
    shareText: "mShare71",
    mshareText: "sShare71",
    img: "Booster/The Loyal Champion - SRH.png",
  },
  [config.enumBadgeMasterId.msId73]: {
    Id: 72,
    MasterId: 72,
    order: 25,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc72",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName72",
    IsProgress: false,
    shareText: "mShare72",
    mshareText: "sShare72",
    img: "Booster/The Loyal Champion - LSG.png",
  },

  [config.enumBadgeMasterId.msId72]: {
    Id: 73,
    MasterId: 73,
    order: 26,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc73",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 2,
    Name: "mName73",
    IsProgress: false,
    shareText: "mShare73",
    mshareText: "sShare73",
    img: "Booster/The Loyal Champion - GT.png",
  },
  [config.enumBadgeMasterId.msId74]: {
    Id: 74,
    MasterId: 53,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc74",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName74",
    IsProgress: false,
    shareText: "mShare74",
    mshareText: "sShare74",
    img: "Booster/TurboCharge-Poweroverseasplayer.png",
  },
  [config.enumBadgeMasterId.msId75]: {
    Id: 75,
    MasterId: 53,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc75",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName75",
    IsProgress: false,
    shareText: "mShare75",
    mshareText: "sShare75",
    img: "Booster/TurboCharge-PowerIndianplayer.png",
  },
  [config.enumBadgeMasterId.msId77]: {
    Id: 77,
    MasterId: 53,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc77",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName77",
    IsProgress: false,
    shareText: "mShare77",
    mshareText: "sShare77",
    img: "Booster/Turbo Charge - Triple Scorer.png",
  },
  [config.enumBadgeMasterId.msId76]: {
    Id: 76,
    MasterId: 53,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc76",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName76",
    IsProgress: false,
    shareText: "mShare76",
    mshareText: "sShare76",
    img: "Booster/TurboCharge-FreeHit.png",
  },
  [config.enumBadgeMasterId.msId78]: {
    Id: 78,
    MasterId: 53,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc78",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName78",
    IsProgress: false,
    shareText: "mShare78",
    mshareText: "sShare78",
    img: "Booster/net.png",
  },
  [config.enumBadgeMasterId.msId79]: {
    Id: 79,
    MasterId: 53,
    order: 9,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc79",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName79",
    IsProgress: false,
    shareText: "mShare79",
    mshareText: "sShare79",
    img: "Booster/sco.png",
  },
  [config.enumBadgeMasterId.msId80]: {
    Id: 80,
    MasterId: 80,
    order: 26,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc80",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName80",
    IsProgress: false,
    shareText: "mShare80",
    mshareText: "sShare80",
    img: "Booster/nam.png",
  },
  [config.enumBadgeMasterId.msId81]: {
    Id: 81,
    MasterId: 81,
    order: 27,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc81",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName81",
    IsProgress: false,
    shareText: "mShare81",
    mshareText: "sShare81",
    img: "Booster/oma.png",
  },
  [config.enumBadgeMasterId.msId82]: {
    Id: 82,
    MasterId: 82,
    order: 28,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc82",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName82",
    IsProgress: false,
    shareText: "mShare82",
    mshareText: "sShare82",
    img: "Booster/png.png",
  },
  [config.enumBadgeMasterId.msId83]: {
    Id: 83,
    MasterId: 83,
    order: 29,
    sText: "sText4",
    pText: "pText4",
    Description: "mdesc83",
    text: "desc1",
    sClass: "m11c-booster",
    isSpec: 1,
    Name: "mName83",
    IsProgress: false,
    shareText: "mShare83",
    mshareText: "sShare83",
    img: "Booster/afg.png",
  },
};

config.boosterBadgesId = [53, 54, 55, 56, 74, 75, 76, 77, 78, 79];

config.jTotalTransferAllowed = 110;
config.jDiffMarginListing = 64;
config.jDiffMarginListingLeaderBoard = 64;
config.jDelayStorage = 120000;
config.checkForMinMembers = 100;
config.enumOptTypeBadge = {
  default: 1,
  transfer: 2,
  captain: 3,
  leagueCreate: 4,
  leagueJoin: 5,
  createTeam: 6,
  pointCalulation: 7,
  home: 8,
};
config.enumTypeTutorial = {
  create: 1,
  transfer: 2,
  transferTeamBar: 3,
  transferResetTeamBar: 4,
};
config.enumWebView = {
  android: "androidfull",
  ios: "ios",
  common: "apptype=",
  platform: "source=",
};
config.enumPullToRefresh = {
  storage: "m11c-PullToRefresh",
  threshold: 8000,
};
config.enumPlatforms = {
  android: 1,
  ios: 2,
  web: 3,
};
config.badgesStorage = "m11c-BadgesStorage";
config.createTeamStorage = "createUserTeam";

config.fieldName = {
  teamName: "teamName",
  firstName: "firstName",
  lastName: "lastName",
  country: "country",
  favTeam: "favTeam",
};

config.radioOptions = [
  { value: "1", name: "Male" },
  { value: "2", name: "Female" },
];

config.CountryList = ["India", "Australia", "West Indies", "England"];

config.FavTeamList = ["RCB", "RR", "MI", "SRH", "CSK", "KKR", "PBKS", "DC"];

config.enumFormState = {
  profile: 1,
  teamName: 2,
};

// total max Fixture
config.MatchNo = 33;

config.CondDate = "03/26/2025 14:00:00";

config.perishDisableState = 2;

config.captainGdDates = {
  captain: 12,
  vCaptain: 13,
  knockOut: 17,
};

config.objCaptainLeague = [
  {
    legid: 3,
  },
  {
    legid: 4,
  },
  {
    legid: 5,
  },
];

config.homeSwiperLeague = 3;
config.maxCount = 20000;

config.initTotalTransfer = 10;
config.totalSubs = { phase1: 221, phase2: 116, phase3: 10 };
config.allMatchHideGd = [];

config.preMatchAbandonedStage = 0;

config.playerSilvate = 1;

config.defaultCountrySelect = 285;

config.hideFixtureList = [];

config.shareLink = [
  {
    platfromId: 1,
    name: "WhatsApp",
    imgName: "whatsapp.svg",
    message:
      window.outerWidth < 768
        ? "https://wa.me/?text="
        : "https://web.whatsapp.com/send?text=",
  },
  // {
  //   platfromId: 2,
  //   name: "Twitter",
  //   imgName: "twitter.svg",
  //   message: "https://twitter.com/intent/tweet?url=",
  // },
  // {
  //   platfromId: 3,
  //   name: "FaceBook",
  //   imgName: "facebook.svg",
  //   message: "https://www.facebook.com/sharer/sharer.php?u=",
  // },
  {
    platfromId: 4,
    name: "Telegram",
    imgName: "telegram.svg",
    message: "https://t.me/share/url?text=",
  },
  {
    platfromId: 5,
    name: "Message",
    imgName: "messenger.svg",
    message: "sms:?body=",
  },
];

config.statsTitles = [
  {
    id: 0,
    transKey: "Players",
    sortingColumn: "TeamName",
    className: "m11c-tbl__cell--thumb",
    sortName: "Name",
    enableSort: false,
  },
  {
    id: 1,
    transKey: "",
    sortingColumn: "",
    className: "m11c-tbl__cell--name",
    sortName: "",
    enableSort: false,
  },

  {
    id: 2,
    transKey: "creadits",
    sortingColumn: "Value",
    className: "m11c-tbl__cell--pts",
    sortName: "Value",
    enableSort: true,
  },
  {
    id: 3,
    transKey: "totalPoints",
    sortingColumn: "OverallPoints",
    className: "m11c-tbl__cell--amt",
    sortByDesc: true,
    sortName: "OverallPoints",
    enableSort: true,
  },
];

config.teamName = {
  // 7: "SA",
  // 5: "NZ",
  // 3: "ENG",
  // 1: "AUS",
  // 2: "BAN",
  // 4: "IND",
  // 1188: "AFG",
  // 6: "PAK",
  // 15: "NED",
  // 8: "SL",
  // 13: "IRE",
  // 9: "WI",
  // 16: "SCO",
  // 20: "NAM",
  // 21: "UAE",
  // 10: "ZIM",
  // 3513: "RCB",
  // 3514: "DC",
  // 3515: "GG",
  // 3516: "UPW",
  // 3517: "MI",
  1111: "MI",
  1105: "RCB",
  1108: "CSK",
  1110: "RR",
  1106: "KKR",
  1379: "SRH",
  1109: "DC",
  1107: "PBKS",
  2955: "GT",
  2954: "LSG",
};

export default config;
